<div class="properties-header">
  <div class="properties-header-left">
    <mat-form-field class="search-input" subscriptSizing="dynamic">
      <input placeholder="Filter"
        matInput
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="applyFilter($event)">
        <mat-chip-grid #chipList>
        </mat-chip-grid>
      </mat-form-field>
      @for (item of searchItems; track item) {
        <mat-chip-option [selectable]="selectable"
          [removable]="removable" (removed)="remove(item)">
          {{item.name}}
          @if (removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-option>
      }
  </div>
  <h2 class="flex-aligned-div deployment-info-btn" (click)="openDeploymentInformationPopup()">
    Deployment information
    <mat-icon data-html="true" style="color:white">info</mat-icon>
  </h2>
</div>
  <div class="example-container new-table-style">
    @if (show) {
      <operationmode-new [header]="header" [list]="list" (onUpdateTable)="onNewRowEvent()"></operationmode-new>
    }
    <table mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      matSort
      (matSortChange)="sortData($event)"
      class="mat-elevation-z8 mat-table-custom" id="operationmodetableprop">

      <ng-container matColumnDef="offset">
        <th mat-header-cell *matHeaderCellDef> Offset </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.Offset"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="mode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="mode"> Mode </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.Mode | bold: dataSource.filter"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="value"> Value </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.Value | bold: dataSource.filter"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="available">
        <th mat-header-cell *matHeaderCellDef>
          <div class="th-label">
            Equipment Status
            <mat-icon matTooltipClass='opmodes-custom-tooltip'
            data-html="true" matTooltip="Property to define between 'Available' and 'Unavailable' equipment status values. &#013;Available operation modes will trigger Return to Operation.">info</mat-icon>
          </div>
          <mat-select class='form-control filter' placeholder='Select' (selectionChange)="filterColumn($event, 'available')">
            <mat-option [value]="undefined">Select</mat-option>
            <mat-option value="true">Available</mat-option>
            <mat-option value="false">Unavailable</mat-option>
          </mat-select>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <p [innerHTML]=" element.isUnitAvailable ? 'Available' : 'Unavailable' | bold: dataSource.filter"></p>
          }
          @if (isEditingRow(element)) {
            <mat-select [(ngModel)]="element.isUnitAvailable">
              <mat-option [value]="true">Available</mat-option>
              <mat-option [value]="false">Unavailable</mat-option>
            </mat-select>
          }
        </td>
      </ng-container>


      <ng-container matColumnDef="isgroupevent">
        <th mat-header-cell *matHeaderCellDef>
          <div class="th-label">
            Is Group Event
            <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Flag to indicate an operation mode is only applicable in group context.">info</mat-icon>
          </div>
          <mat-select class='form-control filter' placeholder='Select' (selectionChange)="filterColumn($event, 'groupevent')">
            <mat-option [value]="undefined">Select</mat-option>
            <mat-option value="true">Yes </mat-option>
            <mat-option value="false">No </mat-option>
          </mat-select>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <mat-checkbox [checked]="element.isGroupEvent" [ngClass]="isEditingRow(element) ? 'black' :''" [disabled]="true"></mat-checkbox>
          }
          @if (isEditingRow(element)) {
            <mat-select [(ngModel)]="element.isGroupEvent">
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="safetyrelated">
        <th mat-header-cell *matHeaderCellDef>
          <div class="th-label">
            Maintenance Priority
            <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Flag to indicate if the operation mode requires a high priority maintenance task, not necessarily leading to a shutdown (e.g. Fire sensor failure).">info</mat-icon>
          </div>
          <mat-select class='form-control filter' placeholder='Select' (selectionChange)="filterColumn($event, 'safetyrelated')">
            <mat-option [value]="undefined">Select</mat-option>
            <mat-option value="true">Yes</mat-option>
            <mat-option value="false">No</mat-option>
          </mat-select>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <mat-checkbox [checked]="element.isSafetyRelated" [ngClass]="isEditingRow(element) ? 'black' :''" [disabled]="true"></mat-checkbox>
          }
          @if (isEditingRow(element)) {
            <mat-select [(ngModel)]="element.isSafetyRelated">
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="potentialmisuse">
        <th mat-header-cell *matHeaderCellDef>
          <div class="th-label">
            Potential Misuse
            <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Flag to indicate if the operation mode could be caused by a potential misuse of the asset.">info</mat-icon>
          </div>
          <mat-select class='form-control filter' placeholder='Select' (selectionChange)="filterColumn($event, 'potentialmisuse')">
            <mat-option [value]="-1">Select</mat-option>
            <mat-option value="true">Yes</mat-option>
            <mat-option value="false">No</mat-option>
          </mat-select>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <mat-checkbox [checked]="element.isPotentialMisuse" [ngClass]="isEditingRow(element) ? 'black' :''" [disabled]="true"></mat-checkbox>
          }
          @if (isEditingRow(element)) {
            <mat-select [(ngModel)]="element.isPotentialMisuse">
              <mat-option [value]="undefined">Select</mat-option>
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="stablealertrule">
        <th mat-header-cell *matHeaderCellDef>
          <div class="th-label">
            Stable Alert Rule
            <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Alert rule selector for Stable and Evaluation environments.">info</mat-icon>
          </div>
          <mat-select class='form-control filter alert-rule-select' placeholder='Select' (selectionChange)="filterColumn($event, 'stablealertruleid')"
            panelClass="select-panel-wide">
            <mat-option [value]="-1">Select</mat-option>
            @for (dep of alertRules; track dep) {
              <mat-option [value]="dep.Id">
                {{ dep.Description }}
              </mat-option>
            }
          </mat-select>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element) && !element.StableAlertRuleCat.startsWith('N/A')) {
            <p [innerHTML]="element.StableAlertRuleCat | bold: dataSource.filter"></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto">
              <mat-select class="edit-select" [(ngModel)]="element.StableAlertRuleCatId">
                @for (dep of alertRules; track dep) {
                  <mat-option [value]="dep.Id">
                    {{ dep.Description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="prodalertrule">
        <th mat-header-cell *matHeaderCellDef>
          <div class="th-label">
            Production Alert Rule
            <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Alert rule selector for Production environment.">info</mat-icon>
          </div>
          <mat-select class='form-control filter alert-rule-select' placeholder='Select' (selectionChange)="filterColumn($event, 'prodalertruleid')"
            panelClass="select-panel-wide">
            <mat-option [value]="-1">Select</mat-option>
            @for (dep of alertRules; track dep) {
              <mat-option [value]="dep.Id">
                {{ dep.Description }}
              </mat-option>
            }
          </mat-select>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element) && !element.ProdAlertRuleCat.startsWith('N/A')) {
            <p [innerHTML]="element.ProdAlertRuleCat | bold: dataSource.filter"></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto">
              <mat-select class="edit-select" [(ngModel)]="element.ProdAlertRuleCatId">
                @for (dep of alertRules; track dep) {
                  <mat-option [value]="dep.Id">
                    {{ dep.Description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="isgoodevent">
        <th mat-header-cell *matHeaderCellDef>
          <tr> Is Good Event? </tr>
          <mat-select class='form-control filter' placeholder='Select' (selectionChange)="filterColumn($event, 'isgoodevent')">
            <mat-option [value]="-1">Select</mat-option>
            <mat-option value="true">Yes</mat-option>
            <mat-option value="false">No</mat-option>
          </mat-select>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <mat-checkbox [checked]="element.IsGoodEvent" [ngClass]="isEditingRow(element) ? 'black' :''" [disabled]="true"></mat-checkbox>
          }
          @if (isEditingRow(element)) {
            <mat-select [(ngModel)]="element.IsGoodEvent">
              <mat-option [value]="undefined">Select {{element.isGoodEvent}}</mat-option>
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="component">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="component"> Component </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <p [innerHTML]="element.Component | bold: dataSource.filter"></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto">
              <input matInput [value]="element.Component" [(ngModel)]="element.Component">
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="eqStatus">
          <div class="th-label">
            Equipment Specific Status
            <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Internal mapping among all controller specific op modes to a predefined op modes. The relationship between op modes and harmonized op modes is 1: 1.">info</mat-icon>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <p [innerHTML]="element.SpecificEquipmentStatus | bold: dataSource.filter"></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto" [ngClass]="notIndicated(element.HarmonizedOperationModeID)">
              <mat-select class="edit-select" [(ngModel)]="element.HarmonizedOperationModeID">
                @for (dep of harmonizedopmodes; track dep) {
                  <mat-option [value]="dep.HarmonizedOperationModeID">
                    {{ dep.HarmonizedDescription }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </td>
      </ng-container>

      <!--<ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="description"> Description </th>
      <td mat-cell *matCellDef="let element" pEditableColumn>
        <mat-form-field floatLabel="auto" *ngIf="isEditingRow(element)">
          <input matInput type="text" [value]="element.Description" [(ngModel)]="element.Description">
        </mat-form-field>
      </td>
    </ng-container>-->

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        @if (!isEditingRow(element)) {
          <button mat-icon-button matTooltip="Edit Row"
            (click)="onRowEditInit(element)">
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (isEditingRow(element)) {
          <button mat-icon-button matTooltip="Cancel Row"
            (click)="onRowEditCancel(element)">
            <mat-icon>rotate_left</mat-icon>
          </button>
        }
        <button mat-icon-button matTooltip="Delete Row"
          (click)="onDelete(element)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; let i = dataIndex;
            columns: columnsToDisplay;"
      class="item"
      [class.alternative2]="isEditingRow(element)">
    </tr>
  </table>
</div>
